/* eslint-disable @typescript-eslint/no-empty-function */
import { reactive } from 'vue';

export type OptionsType = Record<string, number | string>;
export type CallbackType = (e?: KeyboardEvent, options?: OptionsType) => void;

export const useKeyboard = ({
  keydownCallbacks,
  keyupCallbacks = {},
  keydownCallback = () => {},
  keyupCallback = () => {},
  allowDefault = true,
}: {
  keydownCallbacks: Record<string, CallbackType>,
  keyupCallbacks?: Record<string, CallbackType>,
  keydownCallback: (e: KeyboardEvent) => void,
  keyupCallback: (e: KeyboardEvent) => void,
  allowDefault?: boolean,
}): object => {
  const keys: Array<string> = Object.keys(keydownCallbacks);
  const keydowns: Record<string, boolean> = reactive(
    Object.fromEntries(keys.map((key) => [key, false])),
  );

  const onKeydown = (e: KeyboardEvent, options?: OptionsType) => {
    if (!allowDefault) e.preventDefault();

    if (e.key in keydownCallbacks && !keydowns[e.key]) {
      keydowns[e.key] = true;
      keydownCallbacks[e.key](e, options);
    } else if (e.code in keydownCallbacks && !keydowns[e.code]) {
      keydowns[e.code] = true;
      keydownCallbacks[e.code](e, options);
    }

    keydownCallback(e);
  };

  const onKeyup = (e: KeyboardEvent, options?: OptionsType) => {
    if (!allowDefault) e.preventDefault();

    Object.keys(keydowns).forEach((key: string): void => {
      keydowns[key] = false;
    });

    if (e.key in keyupCallbacks) {
      keyupCallbacks[e.key](e, options);
    } else if (e.code in keyupCallbacks) {
      keyupCallbacks[e.code](e, options);
    }

    keyupCallback(e);
  };

  return { onKeydown, onKeyup };
};
